import React from 'react';
import { Box, Container } from '@mui/material';
import ListingHistoryNew from '../../components/admin/ListingHistoryNew';

/**
 * Page d'historique des annonces pour les administrateurs
 */
const ListingHistoryPage = () => {
    return (
        <Container maxWidth="xl" sx={{ py: 3 }}>
            <ListingHistoryNew />
        </Container>
    );
};

export default ListingHistoryPage;
